import React from 'react';
import { cn } from '@/lib/utils';

export const SectionHeader = ({ eyebrow, title, subtitle, actions, className }) => (
  <div className={cn('flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5', className)}>
    <div>
      {eyebrow && <p className="text-[10px] uppercase tracking-[0.22em] text-primary font-semibold mb-1.5">{eyebrow}</p>}
      <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default SectionHeader;
